import React from 'react';
import styled from '@emotion/styled';
import { ReportMeaningsWrapper } from '@seedlang/hoc';
import { pixify } from '@seedlang/utils';
import ReportMeaningsForm from 'components/vocab/report_meanings_form';

const ScreenWrapper = styled.div`
  background: white;
  height: ${props => props.height};
  overflow: auto;
  padding-top: 1px;
`;

class ReportMeaningsScreen extends React.Component {
  render() {
    if (!this.props.open) return null;

    return (
      <ScreenWrapper
        height={this.props.height ? pixify(this.props.height) : '100%'}
      >
        <ReportMeaningsForm
          {...this.props}
        />
      </ScreenWrapper>
    );
  }
}

export default ReportMeaningsWrapper(ReportMeaningsScreen);
